export const BONUS_BUYS_BANNER_TYPE = {
  EQUAL: 'EQUAL',
  TARGET: 'TARGET',
  QUALIFIED: 'QUALIFIED',
  PRICE: 'PRICE'
}
export const BANNER_TYPE = {
  DELIVERY: 'DELIVERY',
  ...BONUS_BUYS_BANNER_TYPE
}
